import { render, staticRenderFns } from "./TypesetType.vue?vue&type=template&id=76439665&"
import script from "./TypesetType.vue?vue&type=script&lang=js&"
export * from "./TypesetType.vue?vue&type=script&lang=js&"
import style0 from "./TypesetType.vue?vue&type=style&index=0&id=76439665&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports